import { render } from "./HomeDeveloperCard.vue?vue&type=template&id=522670c8&scoped=true"
import script from "./HomeDeveloperCard.vue?vue&type=script&lang=js"
export * from "./HomeDeveloperCard.vue?vue&type=script&lang=js"

import "./HomeDeveloperCard.vue?vue&type=style&index=0&id=522670c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522670c8"]])

export default __exports__